export const EMPRESA_LIST_REQUEST = 'EMPRESA_LIST_REQUEST';
export const EMPRESA_LIST_SUCCESS = 'EMPRESA_LIST_SUCCESS';
export const EMPRESA_LIST_FAIL = 'EMPRESA_LIST_FAIL';
 